import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "cover-upload-aria flex-center"
};
var _hoisted_2 = {
    key: 1,
    class: "uploaded-cover-container"
};
var _hoisted_3 = { class: "postimg-container" };
var _hoisted_4 = ["src"];
var _hoisted_5 = {
    key: 1,
    class: "fa-solid fa-triangle-exclamation postimg-container fa-cover-error"
};
var _hoisted_6 = { class: "img-editor-form" };
var _hoisted_7 = { class: "img-editor-modal-footer" };
import { ref, watch, computed, toRef, } from "vue";
import { useStore } from "@/store";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import CustomSVG from "@/components/custom/CustomSVG.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MdEditorCoverUploader',
    props: {
        modelValue: {
            type: [File, null],
            required: true,
        },
        onUpload: {
            type: Function,
            required: true,
        },
        hasImg: {
            type: Boolean,
            required: true,
        },
        // 是否外界的草稿信息已加载完成
        isLoaded: {
            type: Boolean,
            required: true,
        },
    },
    emits: ["update:modelValue"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var store = useStore();
        var acceptType = [
            "png",
            "jpeg",
            "jpg",
            "gif",
            "svg",
            "webp",
            "bmp",
            "jfif",
            "pjpeg",
        ];
        var emit = __emit;
        var props = __props;
        var modelValue = toRef(props, "modelValue");
        var hasImg = ref(props.hasImg);
        var isLoaded = toRef(props, "isLoaded");
        var modelValueFileCastURL = computed(function () {
            console.log("new cover upload:", modelValue.value);
            return modelValue.value ? window.URL.createObjectURL(modelValue.value) : "";
        });
        watch(modelValue, function (newValue) {
            // 当 bindValue 发生变化时，触发 update:bind-value 事件
            console.log("Cover Uploader ModelValue Changed", newValue);
            emit("update:modelValue", newValue); // 双向绑定受控，发送事件使得传来的值能发生变化
        });
        watch(function () { return props.hasImg; }, function (newValue) {
            hasImg.value = newValue;
        });
        // const handleChange = (fileObj: {
        //   fileList: UploadFileInfo[];
        //   file: UploadFileInfo;
        // }) => {
        //   const file = fileObj.file;
        //   const fileExtension = file.name.split(".").pop() || "";
        //   if (acceptType.includes(fileExtension) && file.file) {
        //     modelValue.value = file.file;
        //     hasImg.value = true;
        //     console.log(hasImg.value);
        //     props.onUpload(file.file);
        //   } else {
        //     console.log("文件类型不支持");
        //     window.$message.error("文件类型不支持");
        //   }
        // };
        var isImgLoaded = ref(false), isImgLoadError = ref(false);
        var handleLoadedImg = function (e) {
            console.log("图片加载成功");
            isImgLoaded.value = true;
            isImgLoadError.value = false;
        };
        var handleImgError = function (e) {
            if (!isLoaded.value) {
                return;
            }
            console.log("图片加载失败------------------------==================", e);
            console.log("图片加载失败", "".concat(modelValueFileCastURL.value));
            isImgLoadError.value = true;
            isImgLoaded.value = true;
        };
        var uploadedFile = ref(null);
        var handleChange = function (fileObj) {
            var file = fileObj.file;
            var fileExtension = file.name.split(".").pop() || "";
            if (acceptType.includes(fileExtension) && file.file) {
                // modelValue.value = file.file; // ReadOnly
                uploadedFile.value = file.file;
                editImageUrl.value = window.URL.createObjectURL(uploadedFile.value);
                isShowImgEditModal.value = true;
            }
            else {
                console.log("文件类型不支持");
                window.$message.error("文件类型不支持");
            }
        };
        // 编辑上传的图片相关
        var isShowImgEditModal = ref(false);
        var editImageUrl = ref("");
        var cropperRef = ref(null);
        var croppedBlob = ref(null);
        function defaultSize(_a) {
            var imageSize = _a.imageSize, visibleArea = _a.visibleArea;
            var aria = visibleArea || imageSize;
            return {
                width: aria.width,
                height: aria.height,
            };
        }
        function applyCrop() {
            var cropper = cropperRef.value;
            if (!cropper)
                return;
            var canvas = cropper.getResult().canvas;
            if (!canvas)
                return;
            if (!uploadedFile.value) {
                window.$message.error("请先上传图片");
                return;
            }
            canvas.toBlob(function (blob) {
                if (blob && uploadedFile.value) {
                    croppedBlob.value = blob;
                    hasImg.value = true;
                    var resultImg = new File([blob], uploadedFile.value.name, {
                        type: blob.type,
                        lastModified: Date.now(),
                    });
                    props.onUpload(resultImg);
                    modelValue.value = resultImg; // modalValue 是 ReadOnly 的，虽然这样不会因此而更新这个值，但会使组件显示视图被更新，没有这句会导致上传后显示的没变
                    isShowImgEditModal.value = false;
                    window.$message.success("图片编辑成功");
                }
            }, uploadedFile.value.type);
        }
        return function (_ctx, _cache) {
            var _component_n_upload = _resolveComponent("n-upload");
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_n_button = _resolveComponent("n-button");
            var _component_n_card = _resolveComponent("n-card");
            var _component_n_modal = _resolveComponent("n-modal");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_n_upload, {
                    ref: "upload",
                    "default-upload": false,
                    "directory-dnd": "",
                    onChange: handleChange,
                    "show-file-list": false
                }, {
                    default: _withCtx(function () { return [
                        (!hasImg.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[3] || (_cache[3] = [
                                _createElementVNode("i", { class: "fa-solid fa-image" }, null, -1)
                            ])))
                            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    (!isLoaded.value && !isImgLoaded.value && !isImgLoadError.value)
                                        ? (_openBlock(), _createBlock(CustomSVG, {
                                            key: 0,
                                            icon: "SmallLoading2",
                                            class: "postimg-container"
                                        }))
                                        : _createCommentVNode("", true),
                                    _withDirectives(_createElementVNode("img", {
                                        src: "".concat(modelValueFileCastURL.value),
                                        alt: "cover",
                                        class: "postimg-container",
                                        onLoad: handleLoadedImg,
                                        onError: handleImgError
                                    }, null, 40, _hoisted_4), [
                                        [_vShow, !isImgLoadError.value && isImgLoaded.value]
                                    ]),
                                    (isLoaded.value && isImgLoadError.value)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                    ]; }),
                    _: 1
                }, 512),
                _createVNode(_component_n_modal, {
                    show: isShowImgEditModal.value,
                    "onUpdate:show": _cache[2] || (_cache[2] = function ($event) { return ((isShowImgEditModal).value = $event); }),
                    draggable: "",
                    closable: "",
                    class: "usn"
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_n_card, {
                            style: { "width": "750px" },
                            title: "编辑封面",
                            bordered: false,
                            size: "huge",
                            role: "dialog",
                            "aria-modal": "true"
                        }, {
                            "header-extra": _withCtx(function () { return [
                                _createVNode(_component_n_icon, {
                                    size: "1.6rem",
                                    onClick: _cache[0] || (_cache[0] = function ($event) { return (isShowImgEditModal.value = false); })
                                }, {
                                    default: _withCtx(function () { return _cache[4] || (_cache[4] = [
                                        _createElementVNode("i", { class: "fa-solid fa-square-xmark fa-close-style" }, null, -1)
                                    ]); }),
                                    _: 1
                                })
                            ]; }),
                            footer: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_n_button, {
                                        onClick: _cache[1] || (_cache[1] = function ($event) { return (isShowImgEditModal.value = false); })
                                    }, {
                                        default: _withCtx(function () { return _cache[5] || (_cache[5] = [
                                            _createTextVNode("取消")
                                        ]); }),
                                        _: 1
                                    }),
                                    _createVNode(_component_n_button, {
                                        type: "primary",
                                        onClick: applyCrop
                                    }, {
                                        default: _withCtx(function () { return _cache[6] || (_cache[6] = [
                                            _createTextVNode("确定")
                                        ]); }),
                                        _: 1
                                    })
                                ])
                            ]; }),
                            default: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_unref(Cropper), {
                                        src: editImageUrl.value,
                                        class: "cropper-editor",
                                        ref_key: "cropperRef",
                                        ref: cropperRef,
                                        quality: 1,
                                        "default-size": defaultSize
                                    }, null, 8, ["src"])
                                ])
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ], 64));
        };
    }
});
